import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_missions = _resolveComponent("missions")!
  const _component_live = _resolveComponent("live")!
  const _component_upcoming = _resolveComponent("upcoming")!
  const _component_n_divider = _resolveComponent("n-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_missions, { style: {"margin-top":"1rem"} }),
    _createVNode(_component_live, { style: {"margin-top":"2rem"} }),
    _createVNode(_component_upcoming),
    _createVNode(_component_n_divider)
  ]))
}